import React, { useMemo, useEffect, useState } from "react";
import withRedux from "../withRedux";
import { loadFriends, openPlayerPopup } from "../actions";
import friendRequestSelector from "../selectors/friendRequestSelector";
import friendSelector from "../selectors/friendSelector";
import { User } from "../types";
import { Link } from "react-router-dom";
import Loader from "./loader";
import PlayerItemSmall from "./items/player/small";
import { formatName } from "../libs/formatName";
import { _ } from "libs";

const BuddiesWidget = ({ loadFriends, friends }: { loadFriends: any; friends: User[] }) => {
	const requests = useMemo(() => friendRequestSelector(friends), [friends]);
	const accepted = useMemo(() => friendSelector(friends), [friends]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		let unmounted = false;

		if (friends.length === 0) {
			setLoading(true);
			loadFriends().then(() => {
				if (!unmounted) {
					setLoading(false);
				}
			});
		}

		return () => {
			unmounted = true;
		};
	}, [friends.length, loadFriends]);

	if ((accepted && accepted.length > 0) || (requests && requests.length > 0)) {
		return (
			<div className="dBlock buddiesWidget">
				<div className="horizontal">
					<h5>{_("buddiesWidget.heading")}</h5>
					{requests.length > 0 ? (
						<Link to={"/players/buddies"} className="link" key="link">
							{_("buddiesWidget.requestsCount", requests.length, {
								number: requests.length,
							})}
						</Link>
					) : null}
				</div>
				{loading ? (
					<Loader />
				) : (
					<div className="table defaultSpacing" key="buddies">
						{accepted.map((buddy, key) => {
							return (
								<div onClick={() => openPlayerPopup(buddy.userId)} className="cell clickable" key={key}>
									<PlayerItemSmall
										name={formatName(buddy.firstName, buddy.lastName)}
										photoUrl={buddy.photoUrl}
									/>
								</div>
							);
						})}
					</div>
				)}
			</div>
		);
	} else {
		return null;
	}
};

const mapStateToProps = ({ social: { friends } }, ownProps) => {
	return { friends };
};

export default withRedux({ loadFriends }, mapStateToProps)(BuddiesWidget);
